import { Component, Input } from '@angular/core';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';
import { Finding } from '../../audit.model';

@Component({
  selector: 'iaud-finding-detail-expansion',
  templateUrl: './finding-detail-expansion.component.html',
  styleUrls: ['./finding-detail-expansion.component.scss']
})
export class FindingDetailExpansionComponent {

  dateFormat: string = DISPLAY_DATE_FORMAT;

  _finding: Finding;
  @Input()
  set finding(f: Finding) {
    this._finding = f;
  }
  get finding() {
    return this._finding;
  }

  constructor() { }

}
